import { ReactNode, Suspense } from 'react';
import { Await, useLoaderData } from 'react-router-dom';
import Users from '../../../Domain/components/Settings/Users';
import { Spinner } from '@/Domain/components/Shared/Spinner';

export const LoadingAccountSettingsPage = ({ children }: { children: ReactNode }) => {
  const { settings } = useLoaderData() as { settings: Promise<any> };

  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-full">
          <Spinner className="w-12 h-12" />
        </div>
      }
    >
      <Await resolve={settings}>{children}</Await>
    </Suspense>
  );
};

export default function AccountSettingsPage(): JSX.Element {
  return (
    <div className="flex flex-col gap-10">
      <Users />
    </div>
  );
}
